import { Button, Tag, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import blueBackground from "@/assets/blue-background.png";
import lcaImage from "@/assets/fr/lca.png";
import lcaImage2 from "@/assets/fr/lca2.png";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";
import useSegmentEvent from "@/hooks/useSegmentEvent";

import ServicesSection from "./ServicesSection";

function ProServicesContent() {
  const { t } = useTranslation(["common", "options"]);
  const outboundQueryParams = useOutboundQueryParams("acv");
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <div className="gap-y-xl flex flex-col">
      <div>
        <Typography as="h2" step="1" weight="bold" className="mb-xs">
          {t("options:byProServices.subtitles.lca")}
        </Typography>
        <div className="border-grayscale-xx-light gap-sm flex flex-col rounded-xl border shadow-sm xl:grid xl:grid-cols-2">
          <div className="relative h-[184px] overflow-hidden rounded-xl xl:h-full xl:min-h-[215px]">
            <img
              src={lcaImage}
              className="absolute top-[9%] left-[10%] z-[1] w-[48%]"
            />
            <img
              src={lcaImage2}
              className="absolute top-[30%] left-[42%] z-[2] w-1/2"
            />
            <img
              src={blueBackground}
              className="absolute top-0 left-0 h-full w-full object-cover"
            />
          </div>
          <div className="px-md py-lg">
            <div className="mb-3xs flex justify-between">
              <Typography weight="bold">
                {t("options:byProServices.serviceList.lca.title")}
              </Typography>
              <Tag text={t("options:byProServices.serviceList.lca.tag")} />
            </div>
            <Typography step="-1" weight="semibold" className="text-grayscale">
              {t("options:byProServices.serviceList.lca.description")}
            </Typography>
            <div className="gap-x-sm mt-md flex justify-center">
              <Button
                as={Link}
                to="/lca"
                shape="link"
                intent="secondary"
                size="small"
              >
                {t("common:learnMore")}
              </Button>
              <Button
                as="a"
                href={`https://meetings-eu1.hubspot.com/emmanuelle-vignial/demo-acv${outboundQueryParams}`}
                shouldOpenNewTab
                shape="soft"
                intent="secondary"
                size="small"
                onClick={() => sendSegmentEvent("option_demo_acv")}
              >
                {t("common:bookADemo")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <ServicesSection
        title={t("options:byProServices.subtitles.goFurtherWithMyFootprint")}
        services={["additionalCoaching", "climateFresk"]}
      />
      <ServicesSection
        title={t("options:byProServices.subtitles.complyWithRegulations")}
        services={["ecovadis", "vsme", "cdpAssessment"]}
      />
    </div>
  );
}

export default ProServicesContent;
